import {createAction, createSlice} from "@reduxjs/toolkit";

const initialState = {
  tools:{
    geoCode: {
      isPending: false,
      error: null,
      updatedFile: null,
      isFinished: false
    },
    nearbyScreens: {
      isPending: false,
      error: null,
      updatedFile: null,
      isFinished: false
    }
  },
}

const slice = createSlice({
  name: 'tools',
  initialState,
  reducers:{
    clearStatus: (state, action) => {
      state.tools.geoCode.updatedFile = null;
      state.tools.geoCode.isFinished = false;
    },
    changeIntoGeocode: (state,{payload})=>{
      state.tools.geoCode.isPending = true;
    },
    changeIntoGeocodeSuccess: (state,{payload})=>{
      state.tools.geoCode.updatedFile = payload;
      state.tools.geoCode.isPending = false;
      state.tools.geoCode.isFinished = true;
    },
    changeIntoGeocodeFailure: (state,{payload})=>{
      state.tools.geoCode.error = payload;
      state.tools.geoCode.isPending = false;
      state.tools.geoCode.isFinished = true;
    },

    clearStatusNearbyScreens: (state, action)=>{
      state.tools.nearbyScreens.updatedFile = null;
      state.tools.nearbyScreens.isFinished = false;
    },
    getNearbyScreens: (state, action)=>{
      state.tools.nearbyScreens.isPending = true;
    },
    getNearbyScreensSuccess: (state, {payload})=>{
      state.tools.nearbyScreens.updatedFile = payload;
      state.tools.nearbyScreens.isPending = false;
      state.tools.nearbyScreens.isFinished = true;
    },
    getNearbyScreensFailure: (state, {payload})=>{
      state.tools.nearbyScreens.error = payload;
      state.tools.nearbyScreens.isPending = false;
      state.tools.nearbyScreens.isFinished = true;
    }
  }

});

export const toolsActions={
  clearStatus: createAction("tools/clearStatus"),
  changeIntoGeocode: createAction("tools/changeIntoGeocode"),
  changeIntoGeocodeSuccess: createAction("tools/changeIntoGeocodeSuccess"),
  changeIntoGeocodeFailure: createAction("tools/changeIntoGeocodeFailure"),

  clearStatusNearbyScreens: createAction("tools/clearStatusNearbyScreens"),
  getNearbyScreens: createAction("tools/getNearbyScreens"),
  getNearbyScreensSuccess: createAction("tools/getNearbyScreensSuccess"),
  getNearbyScreensFailure: createAction("tools/getNearbyScreensFailure"),
}

export default slice.reducer;